<template>
  <view
    class="mask"
    wx:class="{{externClass}} {{show ? 'show' : 'hide'}}"
    wx:style="{{externStyle}}"
    bindtap="close"
  ></view>
</template>
<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  props: {
    show: {
      type: Boolean,
      value: false
    },
    closeable: {
      type: Boolean,
      value: true
    },
    externClass: {
      type: String,
      value: ''
    },
    externStyle: {
      type: Object,
      value: () => {}
    }
  },

  computed: {},

  methods: {
    close() {
      if (!this.closeable) return
      this.triggerEvent('close', {
        type: 'mask'
      })
    }
  }
})
</script>

<style scoped lang="stylus" >
.mask
  position fixed
  top 0
  bottom 0
  left 0
  right 0
  background rgb(0, 0, 0)
  z-index 650
  opacity 0
  transition-timing-function linear
  transition-duration 300ms
  transition-property opacity, visibility
  touch-action none
.show
  opacity 0.7
  visibility visible
.hide
  opacity 0
  visibility hidden
</style>
<script name='json'>
module.exports = {
  component: true,
  usingComponents: {}
}
</script>

